import { MobileRouter } from '@/components/MobileRouter/MobileRouter';
import { ChameleonProvider } from '@/pages/video-library/components/ChameleonProvider';
import { StatusListener } from './StatusListener';

interface Props {
    children?: React.ReactNode;
}

const StudioProviders = ({ children }: Props) => {
    return (
        <MobileRouter>
            <ChameleonProvider>
                <StatusListener>{children}</StatusListener>
            </ChameleonProvider>
        </MobileRouter>
    );
};

export default StudioProviders;
